import { Pipe, PipeTransform } from '@angular/core';
import { isDefined } from '@core/utils';

@Pipe({
    name: 'concatArray',
    standalone: false
})
export class ConcatArrayPipe implements PipeTransform {
  transform(values: string[], ...args: any[]): any {

    let params: any = undefined;
    if (isDefined(args[0]) && args.length) {
      if (typeof args[0] === 'string' && args[0].length) {
        // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
        // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
        let validArgs: string = args[0]
          .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
          .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
        try {
          params = JSON.parse(validArgs);
        } catch (e) {
          throw new SyntaxError(`Wrong parameter in TranslatePipe. Expected a valid Object, received: ${args[0]}`);
        }
      } else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
        params = args[0];
      }
    }


    if (values && values.length > 0) {

      //utilizamos metodo set para eliminar duplicados creando un nuevo array
      return [...new Set(values.map(obj => obj[params.property]))].join(', ');
    }
    return '';
  }
}
